import { Divider, Card, Avatar } from 'antd'
import styled from 'styled-components'

import KAISTLOGO from '../images/KAIST_logo_tran.gif'
import RECENT_PAPER_2 from '../images/publications/PASTA_TETCI.png'
import RECENT_PAPER_1 from '../images/publications/TimeCAD_ECMLPKDD_23.png'

const { Meta } = Card

const Publication = styled(Card)`
    .ant-card-meta-avatar {
        float: left;
        margin-bottom: inherit;
    }

    .ant-avatar-image {
        width: 256px !important;
        height: 100% !important;
    }

    @media only screen and (max-width: 768px) {
        .ant-card-meta-avatar {
            float: none;
            margin-bottom: 6px;
        }

        .ant-avatar-image {
            width: 100% !important;
        }

        .ant-card-meta {
            display: block;
        }
    }
`

export default function Home() {
    return <>
        <Divider style={{ marginTop: 0 }} orientation='left'>CURRENT POSITION</Divider>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 24 }}><img src={KAISTLOGO} alt='KAIST LOGO' width='100' /></span>
            <span>
                <h5 style={{ color: '#4caf50', margin: 0 }}>FROM 2020 TO PRESENT</h5>
                <h3 style={{ fontWeight: 700, margin: 0 }}>Ph.D. Candidate in  <a href="https://kaist.ac.kr/en/">KAIST</a> <a href="https://cs.kaist.ac.kr">School of Computing</a> (GPA: 4.18 / 4.30)</h3>
                <h3 style={{ margin: 0 }}>Research Assistant at <a href="https://dm.kaist.ac.kr">Data Mining Lab</a> (Advisor: <a href="https://dm.kaist.ac.kr/jaegil">Prof.Jae-Gil Lee</a>)</h3>
                <h4>Academic Services</h4>
                <ul>
                    <li>Journal Reviewer: IEEE T-ITS (2022~), IEEE TNNLS (2023~), IEEE TMC (2023~), IEEE TETCI (2024~)</li>
                    <li>Conference Reviewer: KDD 2023~25, SDM 2024</li>
                </ul>
            </span>
        </div>
        <Divider orientation='left'>RECENT PUBLICATIONS</Divider>
        <Publication bordered={false} className="recent-publications">
            <Meta
                avatar={<Avatar shape="square" src={RECENT_PAPER_2} />}
                title="PASTA: Neural Architecture Search for Anomaly Detection in Multivariate Time Series"
                description={<p><strong>Trirat, P.</strong> and Lee, J. <br />IEEE Transactions on Emerging Topics in Computational Intelligence (SCIE, IF: 5.3), To Appear</p>}
            />
            <p className="action"><a target="blank" href="/files/PASTA_TETCI.pdf">[PDF]</a> <a target="blank" href="https://github.com/kaist-dmlab/PASTA">[Code]</a></p>
        </Publication>

        <Publication bordered={false} className="recent-publications">
            <Meta
                avatar={<Avatar shape="square" src={RECENT_PAPER_1} />}
                title="Context-Aware Deep Time-Series Decomposition for Anomaly Detection in Businesses"
                description={<p>Nam, Y., <strong>Trirat, P.</strong>, Kim, T., Lee, Y., and Lee, J. <br />In <em>ECML PKDD</em> 2023, Applied Data Science Track Paper</p>}
            />
            <p className="action"><a target="blank" href="https://link.springer.com/chapter/10.1007/978-3-031-43427-3_20">[PDF]</a> <a href="https://www.kaistdmlab.org/_files/ugd/c5ff4f_b9c101208a1043b5a6e4f803020d1e87.pptx?dn=ecmlpkdd23.pptx" target="blank">[PPT]</a> <a target="blank" href="https://github.com/kaist-dmlab/Time-CAD">[Code]</a></p>
        </Publication>
        <Divider orientation='left'>RESEARCH INTERESTS</Divider>
        <p>Data Mining and Analysis, Automated Machine Learning (AutoML), Intelligent Learning Systems, Continual Learning, Web Development</p>
    </>
}